import React from 'react';

export const ArrowRestorePrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.17592 2.68272C6.53535 3.10205 6.48678 3.73335 6.06746 4.09277L3.9707 5.89L6.12377 8.04307C6.5143 8.4336 6.5143 9.06676 6.12377 9.45729C5.73325 9.84781 5.10009 9.84781 4.70956 9.45729L1.79289 6.54062C1.59593 6.34366 1.49005 6.07348 1.50074 5.79514C1.51143 5.5168 1.63772 5.25553 1.84921 5.07426L4.76588 2.57426C5.1852 2.21484 5.8165 2.2634 6.17592 2.68272Z"
        fill="#774EFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 5.8335C1.5 5.28121 1.94772 4.8335 2.5 4.8335H12.0808C15.4858 4.8335 18.3625 7.59944 18.4951 11.0029C18.6356 14.6006 15.6774 17.6668 12.0808 17.6668H4.99917C4.44688 17.6668 3.99917 17.2191 3.99917 16.6668C3.99917 16.1145 4.44688 15.6668 4.99917 15.6668H12.0808C14.5451 15.6668 16.5927 13.5414 16.4966 11.0809L16.4966 11.0808C16.4058 8.75089 14.4117 6.8335 12.0808 6.8335H2.5C1.94772 6.8335 1.5 6.38578 1.5 5.8335Z"
        fill="#774EFF"
      />
    </svg>
  );
};
